import moment from "moment";
import { map } from "lodash";

export function selectFormatEmployee(
  data,
  label = "full_name",
  value = "id",
  key = "id"
) {
  return map(data, (list) => ({
    label: list[label] || "",
    value: list[value] || "",
    key: list[key] || "",
  }));
}

export function selectFormatClientCategory(
  data,
  label = "name",
  value = "id",
  key = "id"
) {
  return map(data, (list) => ({
    label: list[label] || "",
    value: list[value] || "",
    key: list[key] || "",
  }));
}

export function selectFormatTaskType(
  data,
  label = "name",
  value = "id",
  key = "id"
) {
  return map(data, (list) => ({
    label: list[label] || "",
    value: list[value] || "",
    key: list[key] || "",
  }));
}

export function selectFormatEmployeeTask(
  data,
  label = "name",
  value = "id",
  key = "id"
) {
  return map(data, (list) => ({
    label: list[label] || "",
    value: list[value] || "",
    key: list[key] || "",
  }));
}

export function dateFormat(date = new Date(), format = "YYYY-MM-DD HH:mm:ss") {
  return moment.utc(date).local().format(format);
}

export function formatInputDateTime(date) {
  return moment.utc(date).local().format("YYYY-MM-DDTHH:mm:ss");
}

export function secondsToTime(e) {
  const m = Math.floor((e % 3600) / 60)
      .toString()
      .padStart(2, "0"),
    s = Math.floor(e % 60)
      .toString()
      .padStart(2, "0");

  return m + ":" + s;
}
